import * as React from 'react';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import propz from 'propz';
import { getFullName, searchFunctionSchoolPlayers } from 'Src/helpers/autocomplete/autocomplete';
import { Autocomplete } from 'Src/components/Autocomplete/Autocomplete';
import { AppUser } from 'Src/views/App/App';
import { Component } from 'react';
import { Button } from 'Src/components/Button/Button';
import './SchoolEventJobForm.scss';

interface Props {
  schoolEvent: any;
  onSubmit: (data) => void;
  onCancel: (event) => void;
  user: AppUser;
  eventTasks: any;
  eventTaskIndex: number;
}

const EventJobSchema = Yup.object().shape({
  text: Yup.string().required('Required'),
  players: Yup.array().min(1)
});

interface State {
  players: any[];
}

export class SchoolEventJobForm extends Component<Props, State> {
  constructor(props) {
    super(props);
    const { eventTasks, eventTaskIndex } = this.props;

    this.state = {
      players: propz.get(eventTasks, [eventTaskIndex, 'assignees'], [])
    };
  }

  getPlayers = (text: string) => {
    const { schoolEvent, user } = this.props;
    const playersWithSelect = [...this.state.players];
    const eventPlayers = propz.get(schoolEvent, ['players'], []);
    const uniqPlayersWithSelect = eventPlayers.filter(uniqPlayer =>
      playersWithSelect.every(playerWithSelect => playerWithSelect.userId !== uniqPlayer.userId)
    );

    return searchFunctionSchoolPlayers(user, text, uniqPlayersWithSelect);
  };

  renderPlayers = (players, setFieldValue) => {
    return players.map(player => {
      return (
        <div key={player.userId} className="eventJobForm__assignee">
          <Autocomplete
            onSelect={() => {}}
            searchFunction={() => {}}
            getElementTitle={getFullName}
            defaultItem={player}
            disabled
          />
          <div className="eventJobForm__remove">
            <button
              type="button"
              className="eventJobForm__removeButton"
              aria-label={`Remove ${getFullName(player)}`}
              onClick={() => {
                const playersFiltered = players.filter(p => p.userId !== player.userId);
                setFieldValue('players', playersFiltered);
                this.setState({
                  players: playersFiltered
                });
              }}
            >
              <span>&times;</span>
            </button>
          </div>
        </div>
      );
    });
  };

  render() {
    const { eventTasks, eventTaskIndex } = this.props;
    const isExistTask = eventTaskIndex !== -1;

    const jobInitial = {
      text: isExistTask ? propz.get(eventTasks, [eventTaskIndex, 'text'], '') : '',
      players: isExistTask ? propz.get(eventTasks, [eventTaskIndex, 'assignees'], []) : []
    };
    return (
      <div className="eventJobForm">
        <Formik
          initialValues={jobInitial}
          validationSchema={EventJobSchema}
          onSubmit={values => {
            this.props.onSubmit(values);
          }}
        >
          {({ setFieldValue, touched, errors, values }) => (
            <Form>
              <div className="eventJobForm__intro">Describe the task and choose who is responsible for it.</div>
              <div className="eventJobForm__field">
                <label htmlFor="event-job-description">Job description</label>
                <Field
                  id="event-job-description"
                  component="textarea"
                  rows={5}
                  name="text"
                  className="form-control"
                  placeholder="For example, collect the team kit after the match"
                />
                {touched.text && errors.text ? <div className="eventJobForm__error">{String(errors.text)}</div> : null}
              </div>
              <div className="eventJobForm__field">
                <label>Assignees</label>
                <div className="eventJobForm__hint">Select one or more event participants.</div>
                <div className="eventJobForm__assignees">{this.renderPlayers(values.players, setFieldValue)}</div>
                <Field name="players">
                  {({ field }) => {
                    return (
                      <Autocomplete
                        searchFunction={this.getPlayers}
                        getElementTitle={getFullName}
                        customClass="mFullWidth eventJobForm__picker"
                        defaultItem={undefined}
                        onSelect={player => {
                          player.userId = player.id;
                          player.permissionId = player.permissions[0]?.id;
                          const players = [].concat(values.players, player);
                          setFieldValue('players', players);
                          this.setState({
                            players: players
                          });
                        }}
                      />
                    );
                  }}
                </Field>
                {touched.players && errors.players ? (
                  <div className="eventJobForm__error">Please select at least one assignee.</div>
                ) : null}
              </div>

              <div className="eventJobForm__actions">
                <Button onClick={this.props.onCancel} text="Cancel" customClass="sit-btn sit-btn--secondary" />
                <button type="submit" className="sit-btn sit-btn--primary">
                  {isExistTask ? 'Save changes' : 'Create job'}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}
